/**
 * Created by ren_zhangjing on 2017/7/5.
 */
const host = '',
  project = '',
  prefix = host + project +'/api/';
// oldpwd,newpwd,renewpwd
let apis = {
    
  // 2021
  SignUpCourse: prefix + 'SignUp/Course', //get  choosecourse
  Jump: prefix + 'Index/Jump', //choosecourse
  SelectCourse: prefix + 'SignUp/SelectCourse', //choosecourse
  Try: prefix + 'SignUp/Try', //试听
  SignUpDetails: prefix + 'SignUp/Details', //payment
  Invoice: prefix + 'SignUp/Invoice', //payment
  SignUpReSignUp: prefix + 'SignUp/ReSignUp', //payment
  SignUp: prefix + 'SignUp/Pay', //login
  OrderQuery: prefix + 'SignUp/OrderQuery', //login
  Statistics: prefix + 'Index/Statistics', //login
  Course: prefix + 'Course/List', //我的课程 type=1 等待考试 type=3 考试通过 type=0 未完成
  CourseDetails: prefix + 'Course/Details', //courseDetail
  CoursePlay: prefix + 'Course/Play', //courseDetail
  Progress: prefix + 'Course/Progress', //courseDetail
  Questions: prefix + 'Exam/Questions', //onlintest
  ExamSubmit: prefix + 'Exam/Submit', //onlintest
  OrderList: prefix + 'Order/List', //订单列表
  InvoiceList: prefix + 'Invoice/List', //发票列表
//   Notice: prefix + 'Index/Notice', //
  NoticeList: prefix + 'Notice/List', //发票列表
  NoticeDetails: prefix + 'Notice/Details', //发票列表
  NoticeSearch: prefix + 'Notice/Search', //发票列表
  GetPayUrl: prefix + 'SignUp/GetPayUrl', //发票列表
  
  GetPayCode: prefix + 'SignUp/GetPayCode', //发票列表
  Times: prefix + 'Course/Times', //
  LoginOut: prefix + 'Index/Logout', //
  CourseChapter: prefix + 'Course/Chapter', //
  CourseAssess: prefix + 'Course/Assess', // 评价提交评价 参数 classid star1 star2 star3  assess
  CourseDelAssess: prefix + 'Course/DelAssess', // 删除评价 参数 参数 classid
  GetOpenID: prefix + 'SignUp/GetOpenID', // 获取openid
  WXPay: prefix + 'SignUp/WXPay', // 获取openid
  Upload3: prefix + 'Face/Upload', // 人脸识别
  UserDetails: prefix + 'User/Details', // 个人信息
  UserUpdate: prefix + 'User/Update', //提交个人信息
  Login: prefix + 'User/Login', //提交个人信息
  SignUpCheck: prefix + 'SignUp/Check', //选课年份提交
  GetYears: prefix + 'SignUp/GetYears', //获取可选课程年份
  CourseGetYears: prefix + 'Course/GetYears', //我的课程获取年份
  CourseList: prefix + 'Index/CourseList', //课程列表
  GoPay: prefix + 'Order/GoPay', //订单列表去支付
  Cancel: prefix + 'Order/Cancel', //订单列表取消订单
  PostInvoice: prefix + 'SignUp/PostInvoice', //补开发票列表
  SignUpPostInvoice: prefix + 'SignUp/PostInvoice', //缴费发票


  CourseGoPay: prefix + 'Course/GoPay', //课程下的去支付
  CourseGoSelect: prefix + 'Course/GoSelect', //课程下的去选课
  QRCode: prefix + 'Index/QRCode', //
  ToPublicClass: prefix + 'Course/ToPublicClass', //跳转公需课
  Questionnaire: prefix + 'Index/Questionnaire', // 问卷调查
  IndexIsQ: prefix + 'Index/IsQ', // 判断学习完成

  ContrastStatus: prefix + 'Face/ContrastStatus', //人脸识别二维码查询
  MobileQRCode: prefix + 'Face/MobileQRCode', //人脸识别二维码
  Upload3: prefix + 'Face/Upload', // 人脸识别
  MakeUp: prefix + 'Invoice/MakeUp',  //修改发票
  

  
};
export default apis;



// WEBPACK FOOTER //
// ./src/api/index.js